import React from 'react'
import { Link } from 'react-router-dom'

const ClubManagementDetail = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Club Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Club Management Detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/club-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Club Detail</h2>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label>Club Name</label>
                                        <input type="text" className="form-control" defaultValue="Brooklyn Strikers" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label>Club Director</label>
                                        <input type="text" className="form-control" defaultValue="Robert Sean" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label>Teams Count</label>
                                        <input type="text" className="form-control" defaultValue={20} readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="inp_grp">
                                        <label>Country</label>
                                        <input type="text" className="form-control" defaultValue="USA" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="inp_grp">
                                        <label>Status</label>
                                        <input type="text" className="form-control" defaultValue="Pending" readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Teams Detail</h2>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <Link to="/team-management" className="teams_card">
                                            <img src="images/team/t2.jpg" alt />
                                            <div>
                                                <h5>Eagles FC</h5>
                                                <ul>
                                                    <li>
                                                        <p>Wins: <span>10</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Losses: <span>5</span></p>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <p>Games Count: <span>15</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Player Count: <span>16</span></p>
                                                    </li>
                                                </ul>
                                                <h4>Coach: John Clark</h4>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <Link to="/team-management" className="teams_card">
                                            <img src="images/team/t1.jpg" alt />
                                            <div>
                                                <h5>Hawks United</h5>
                                                <ul>
                                                    <li>
                                                        <p>Wins: <span>10</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Losses: <span>5</span></p>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <p>Games Count: <span>15</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Player Count: <span>16</span></p>
                                                    </li>
                                                </ul>
                                                <h4>Coach: Robert Sean</h4>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <Link to="/team-management" className="teams_card">
                                            <img src="images/team/t3.jpg" alt />
                                            <div>
                                                <h5>Hawks United</h5>
                                                <ul>
                                                    <li>
                                                        <p>Wins: <span>10</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Losses: <span>5</span></p>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <p>Games Count: <span>15</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Player Count: <span>16</span></p>
                                                    </li>
                                                </ul>
                                                <h4>Coach: Richard Thomas</h4>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ClubManagementDetail